import { CalendarCheck, CalendarRange, Check } from "lucide-react";

const PLAN_BENEFITS = [
  "Routine lawn care on a schedule",
  "Ongoing property maintenance",
  "Seasonal landscaping refreshes",
  "Tree and shrub maintenance",
  "Customized lawn treatment",
];

const PLANS = [
  {
    id: "monthly",
    icon: CalendarCheck,
    name: "Monthly Maintenance",
    description:
      "A dedicated crew visits your property every month to keep your lawn, beds, and shrubs in top shape — without you having to think about it.",
    button: "Request Monthly Plan",
    prefill: "Monthly Maintenance Plan",
  },
  {
    id: "annual",
    icon: CalendarRange,
    name: "Annual Maintenance",
    description:
      "Year-round care across every season: lawn care, seasonal planting, cleanups, and tree and shrub maintenance planned for the whole year.",
    button: "Request Annual Plan",
    prefill: "Annual Maintenance Plan",
  },
];

export default function Plans({ onRequestEstimate }) {
  return (
    <section id="plans" data-testid="plans-section" className="py-20 md:py-28 px-4 sm:px-6 lg:px-8 bg-forest scroll-mt-20">
      <div className="max-w-7xl mx-auto">
        <div className="max-w-2xl">
          <span className="text-brand font-bold uppercase tracking-widest text-sm">Lawn Care Maintenance Plans</span>
          <h2 className="mt-3 font-heading font-bold text-white text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-snug">
            Keep Your Property Looking Its Best, All Year
          </h2>
          <div className="mt-5 h-1.5 w-24 bg-brand rounded-full" aria-hidden="true" />
          <p className="mt-4 text-white/85 text-lg leading-relaxed">
            Recurring service means your property never falls behind. Pricing depends on your property
            size and service needs — request a free on-site estimate and we will build a plan around you.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl">
          {PLANS.map((plan) => (
            <article
              key={plan.id}
              data-testid={`plan-card-${plan.id}`}
              className="bg-white border border-border p-8 rounded-xl flex flex-col gap-6 hover:border-brand transition-colors duration-200"
            >
              <span className="w-12 h-12 rounded-full bg-brand-light flex items-center justify-center">
                <plan.icon className="w-6 h-6 text-brand" aria-hidden="true" />
              </span>
              <div>
                <h3 className="font-heading font-bold text-ink text-2xl tracking-tight">{plan.name}</h3>
                <p className="mt-3 text-[#4B5563] leading-relaxed">{plan.description}</p>
              </div>
              <ul className="flex flex-col gap-2.5">
                {PLAN_BENEFITS.map((benefit) => (
                  <li key={benefit} className="flex items-start gap-2.5 text-sm text-ink">
                    <Check className="w-4 h-4 text-leaf mt-0.5 shrink-0" aria-hidden="true" />
                    {benefit}
                  </li>
                ))}
              </ul>
              <p className="text-xs text-[#4B5563]">
                Personalized pricing after a free on-site estimate.
              </p>
              <button
                type="button"
                data-testid={`plan-request-button-${plan.id}`}
                onClick={() => onRequestEstimate(plan.prefill)}
                className="mt-auto inline-flex items-center justify-center bg-brand text-white font-semibold rounded-full px-8 py-3.5 hover:bg-brand-hover transition-colors duration-200 shadow-sm"
              >
                {plan.button}
              </button>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
